import { Log } from '@devanjs/log';
import { services } from './services';
import type { PossiblyAsyncIntegration } from './types/asyncIntegration';
import type { Integration } from './types/integration';
import type { IntegrationsStore } from './types/integrationsStore';

export const isResolved = <I extends Integration>(
  integration: PossiblyAsyncIntegration<I>,
): integration is I => integration.resolved;

const resolvers: Record<string, Promise<Integration>> = {};

export const resolve = async <
  I extends Integration,
  Integrations extends Record<string, PossiblyAsyncIntegration>,
>(
  integration: PossiblyAsyncIntegration<I>,
  store: IntegrationsStore<Integrations>,
): Promise<I> => {
  if (resolvers[integration.code] === undefined) {
    resolvers[integration.code] = (async () => {
      Log.tag('integrations').space().lightBlue('Resolving').info(integration.code);

      let resolved: I;

      if (!isResolved(integration)) {
        resolved = await integration.resolver();
      } else {
        resolved = integration;
      }

      if (services.resolver !== undefined) {
        resolved = await services.resolver(resolved);
      }

      Log.tag('integrations').space().lightBlue('Resolved').info(integration.code);

      // @ts-expect-error
      return (store.integrations[integration.code] = resolved);
    })();
  }

  return (await resolvers[integration.code]) as I;
};
